module.exports = __webpack_public_path__ + "static/media/instagramIcon.60ba633d.png";